import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";


export class ProfileService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getProfileDetail() {

        const adminInfoReq = this.httpClient.get(
            `admins/information`
        )

        const adminAvatarInfoReq = this.httpClient.get(
            `admins/avatars`
        )


        return new Promise((resolve, reject) => {
            axios.all([adminInfoReq, adminAvatarInfoReq])
                .then(axios.spread((adminInfo, avatarInfo) => {
                    resolve({
                        info: adminInfo,
                        url: avatarInfo.url
                    })
                })).catch(reject)
        })
    }

    updateProfileInfo(profileJsonInfo) {

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `admins/information`,
                profileJsonInfo,
            ).then(resolve).catch(reject)
        })

    }


    updateUserName(newUsername) {

        let formData = new URLSearchParams()
        formData.append("newUsername", newUsername)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/x-www-form-urlencoded"
            ).patch(
                `admins/username`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }

    changePassword(lastPassword, newPassword) {

        let formData = new URLSearchParams()
        formData.append("oldPassword", lastPassword)
        formData.append("newPassword", newPassword)

        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/x-www-form-urlencoded").patch(
                `admins/password`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }

    updateAdminAvatar(avatarFile) {
        return new Promise((resolve, reject) => {
            let data = new FormData()
            data.append('file', avatarFile)
            this.httpClient.patch(`admins/avatars`,
                {}, data)
                .then(resolve).catch(reject)
        })
    }

    getProfileDetailById(managerId) {


        const infoReq = this.httpClient.get(
            `admins/${managerId}/information`
        )
        const avatarReq = this.httpClient.get(
            `admins/${managerId}/avatars`
        )


        return new Promise((resolve, reject) => {
            axios.all([infoReq, avatarReq])
                .then(axios.spread((info, avatar) => {
                    resolve({
                        info,
                        url: avatar.url
                    })
                })).catch(reject)
        })


    }

    updateProfileDetailById(managerId, profileJsonInfo) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `admins/${managerId}/information`,
                profileJsonInfo,
            ).then(resolve).catch(reject)
        })

    }

    getManagerRolesList(managerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/${managerId}/roles`
            ).then(resolve).catch(reject)
        })
    }


    updateManagerRoles(managerId, roles) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `admins/${managerId}/roles`,
                {},
                {
                    roles
                }
            ).then(resolve).catch(reject)
        })
    }

    updateManagerUserNameById(managerId, newUsername) {

        let formData = new URLSearchParams()
        formData.append("newUsername", newUsername)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/x-www-form-urlencoded"
            ).patch(
                `admins/${managerId}/username`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }


    changeManagerPasswordById(managerId, newPassword) {

        let formData = new URLSearchParams()
        formData.append("newPassword", newPassword)

        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/x-www-form-urlencoded").patch(
                `admins/${managerId}/password`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }

    getManagerEnabled(managerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/${managerId}/enabled`
            ).then(resolve).catch(reject)
        })
    }

    changeManagerEnabledState(managerId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `admins/${managerId}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    updateOwnAvatar(file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `admins/avatars`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }

    updateManagerAvatar(id, file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `admins/${id}/avatars`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }


}